import { useContext, useEffect, useState } from 'react'
import { ThemeContext } from '../../../assets/theme/ThemeProvider'
import { StyleProp, ViewStyle } from 'react-native'

export interface Props {
    onClientChange: (value) => void
    key?: string
    clients: any[]
    identifier: string
    selectedClient?: any
    containerStyle?: StyleProp<ViewStyle>
}

const useMultiselectClients = (props: Props) => {
    const { theme } = useContext<any>(ThemeContext)
    const [clients, setClients] = useState<any[]>([])
    const [selectedClient, setSelectedClient] = useState(null)

    const handleChange = e => {
        setSelectedClient(e)
        props.onClientChange(e.map(i => i.code))
    }

    useEffect(() => {
        if (props.selectedClient) {
            setSelectedClient(props.selectedClient)
        }
    }, [props.selectedClient])

    useEffect(() => {
        if (props.clients) {
            setClients(props.clients)
        }
    }, [props.clients])

    return [{ theme, clients, selectedClient, handleChange }]
}

export default useMultiselectClients
